export const ADD_SCENARIO_VARIATION_ITEMS = "ADD_SCENARIO_VARIATION_ITEMS";

export const ADD_VARIATION_UUID_TO_LIST = "ADD_VARIATION_UUID_TO_LIST";
export const ADD_VARIATION_NAME_TO_LIST = "ADD_VARIATION_NAME_TO_LIST";

export const ADD_GROUP = "ADD_GROUP";

export const SET_CREATE_GROUP_REQUEST = "SET_CREATE_GROUP_REQUEST";
export const SET_CREATE_GROUP_SUCCESS = "SET_CREATE_GROUP_SUCCESS";
export const SET_CREATE_GROUP_ERROR = "SET_CREATE_GROUP_ERROR";

export const ADD_BULK_VARIATION_TO_LIST = "ADD_BULK_VARIATION_TO_LIST";
export const ADD_BULK_VARIATION_COUNT = "ADD_BULK_VARIATION_COUNT";

export const SET_CURRENT_PAGE_NUMBER = "SET_CURRENT_PAGE_NUMBER";
